var render = function render(){var _vm=this,_c=_vm._self._c;return _c('overview',{attrs:{"property":this.property,"parameters":['color']},scopedSlots:_vm._u([{key:"list-item-before",fn:function(prop){return [_c('div',{staticClass:"color-indicator-container"},[_c('list-color-indicator',{attrs:{"color":prop.item.color}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }